import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { SubmitButton } from "../../components/Input";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";

const AddEmailConfigForm = () => {
  const [operation, setOperation] = useState("Add");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    smtp_host: "",
    smtp_username: "",
    smtp_password: "",
    smtp_secure: "",
    smtp_port: "",
    emailfrom: "",
    mailer_name: "",
  });

  const fetchEmailConfig = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/emailconfig/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && !isNaN(id)) {
      setOperation("Edit");
      fetchEmailConfig(id);
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    const {
      smtp_host,
      smtp_username,
      smtp_password,
      smtp_secure,
      smtp_port,
      emailfrom,
      mailer_name,
    } = formData;

    if (
      !smtp_host ||
      !smtp_username ||
      !smtp_password ||
      !smtp_secure ||
      !smtp_port ||
      !emailfrom ||
      !mailer_name
    ) {
      Swal.fire({
        title: "Missing Fields",
        text: "Please fill in all required fields.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const response = await axios.post(`${API_URL}settings/emailconfig/save`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/Settings/EmailConfig");
      }
    } catch (error) {}
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <input type="hidden" name="id" value="1" /> {/* Dummy ID */}
            <div className="panel-heading border-0">
              <span className="panel-title">
                {operation == "Edit" ? "Edit " : "Add "}Email Confuguration
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* API Key */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">SMTP Host</label>
                    <input
                      type="text"
                      className="form-control"
                      name="smtp_host"
                      value={formData.smtp_host}
                      onChange={handleInputChange}
                      placeholder="Enter SMTP Host"
                    />
                  </div>
                </div>

                {/* SMTP Username */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">SMTP Username</label>
                    <input
                      type="text"
                      className="form-control"
                      name="smtp_username"
                      value={formData.smtp_username}
                      onChange={handleInputChange}
                      placeholder="Enter SMTP Username"
                    />
                  </div>
                </div>
                {/* SMTP Password */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">SMTP Password</label>
                    <input
                      type="text"
                      className="form-control"
                      name="smtp_password"
                      value={formData.smtp_password}
                      onChange={handleInputChange}
                      placeholder="Enter SMTP Password"
                    />
                  </div>
                </div>
                {/* SMTP Secure */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">SMTP Secure</label>
                    <input
                      type="text"
                      className="form-control"
                      name="smtp_secure"
                      value={formData.smtp_secure}
                      onChange={handleInputChange}
                      placeholder="Enter SMTP Secure"
                    />
                  </div>
                </div>
                {/* SMTP Port */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">SMTP Port</label>
                    <input
                      type="text"
                      className="form-control"
                      name="smtp_port"
                      value={formData.smtp_port}
                      onChange={handleInputChange}
                      placeholder="Enter SMTP Port"
                    />
                  </div>
                </div>
                {/* Email From */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">Email From</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emailfrom"
                      value={formData.emailfrom}
                      onChange={handleInputChange}
                      placeholder="Enter Email From"
                    />
                  </div>
                </div>
                {/* Mailer Name */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">Mailer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mailer_name"
                      value={formData.mailer_name}
                      onChange={handleInputChange}
                      placeholder="Enter Mailer Name"
                    />
                  </div>
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/EmailConfig"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default AddEmailConfigForm;
